import { Versions, VersionsFilter } from '@usimweb/core/models';
import { MakeEntitie } from '../makeentitie';

import * as fromVersions from '../actions/versions.action';

export interface VersionState {
  entities: { [uuid: string]: Versions };
  loading: boolean;
  loaded: boolean;
  filter: VersionsFilter;
  newVersion: boolean;
  currentVersion: Versions;
}

export const initialState: VersionState = {
  entities: {},
  loading: false,
  loaded: false,
  filter: { statusFilter: '-', labelFilter: '-', searchFilter: '' },
  newVersion: false,
  currentVersion: {} as Versions,
};

export function reducer(state = initialState, action: fromVersions.VersionsActions): VersionState {
  switch (action.type) {
    case fromVersions.LOAD_VERSIONS:
    case fromVersions.POLL_VERSIONS: {
      return {
        ...state,
        loading: true,
      };
    }
    case fromVersions.LOAD_VERSIONS_FAIL: {
      return {
        ...state,
        loaded: false,
        loading: false,
      };
    }

    case fromVersions.LOAD_VERSIONS_SUCCESS:
    case fromVersions.POLL_VERSIONS_SUCCESS: {
      const versions = action.payload;
      const entities = MakeEntitie.versions(state, versions);

      // const url = window.location.href;
      // const lastSlashIndex = url.lastIndexOf('/');
      // const index = Number(url.substring(lastSlashIndex + 1)) || 0;

      return {
        ...state,
        loading: false,
        loaded: true,
        entities,
        //currentVersion: versions[index],
      };
    }

    case fromVersions.CREATE_VERSION_SUCCESS: {
      const version = action.payload;
      const entities = {
        ...state.entities,
        [version.uuid]: version,
      };

      return {
        ...state,
        entities,
      };
    }

    case fromVersions.DELETE_VERSION_SUCCESS: {
      const versions = action.payload;
      const { [versions.uuid]: removed, ...entities } = state.entities;

      return {
        ...state,
        entities,
        loading: false,
        loaded: false,
      };
    }

    case fromVersions.GET_VERSION_BY_ID_SUCCESS: {
      const version = action.payload;
      const uuid = version.uuid;

      const entities = { ...state.entities, [uuid]: version };

      return {
        ...state,
        entities,
        loading: false,
        loaded: true,
      };
    }

    case fromVersions.CLEAR_VERSIONS: {
      return {
        ...state,
        entities: {},
        loading: false,
        loaded: false,
      };
    }

    case fromVersions.RENAME_VERSION_SUCCESS: {
      const obj = action.payload;
      let version = { ...state.entities[obj.uuid], ['name']: obj.name };
      let entities = { ...state.entities, [version.uuid]: version };

      if ('history' in obj) {
        const history = obj.history as Versions[];
        const index = history.findIndex((x: any) => x.uuid === obj.uuid);

        version = { ...version, ['history']: history, ...history[index], ['name']: obj.name };
        entities = { ...state.entities, [version.uuid]: version };
      }
      return {
        ...state,
        entities,
      };
    }

    case fromVersions.SET_FILTER: {
      const newState = { ...state, filter: action.payload };
      return newState;
    }

    case fromVersions.GET_VERSIONS: {
      const versions = action.payload;
      const entities = MakeEntitie.versions(state, versions);

      return {
        ...state,
        loading: false,
        loaded: true,
        entities,
      };
    }

    case fromVersions.GO_NEW_VERSION: {
      return {
        ...state,
        newVersion: true,
      };
    }

    case fromVersions.SET_CURR_VERSION: {
      const version = action.payload;

      return {
        ...state,
        currentVersion: version,
      };
    }

    case fromVersions.GET_CURR_VERSION: {
      const uuid = action.payload;
      return {
        ...state,
        loading: false,
        loaded: true,
        currentVersion: state.entities[uuid],
      };
    }

    case fromVersions.CLEAR_CURR_VERSION: {
      return {
        ...state,
        currentVersion: {} as Versions,
      };
    }

    case fromVersions.POLL_VERSION_SUCCESS: {
      const version = action.payload;
      const entities = {
        ...state.entities,
        [version.uuid]: version,
      };
      return {
        ...state,
        entities,
      };

      // const vela = version.vela;

      // if (vela.energyLabel || vela.volume || vela.heatLossW) {
      //   console.log('reducer');
      //   console.log(fromVersions.POLL_VERSION_SUCCESS);

      //   return {
      //     ...state,
      //     entities,
      //   };
      // }
    }
  }

  return state;
}

export const getVersionsEntities = (state: VersionState) => state.entities;
export const getVersionsLoading = (state: VersionState) => state.loading;
export const getVersionsLoaded = (state: VersionState) => state.loaded;
export const getVersionsFiltered = (state: VersionState) => state.filter;

export const getNewVersionClicked = (state: VersionState) => state.newVersion;
export const getCurrentVersion = (state: VersionState) => state.currentVersion;
